module.exports = __webpack_public_path__ + "img/forecast_icon-sleet_iphone.f2622fb6.png";